import { INVALID_MOVE } from 'boardgame.io/core';
import { debug } from '../../utils/debug';
import type { Ctx } from 'boardgame.io';
import type { AoSGameState } from '../../types';

/**
 * Production 配置を取り消す Move
 *
 * 1個目の配置後に「1個目の選択状態に戻す」ために使用
 *
 * @param G - ゲーム状態
 * @param ctx - Boardgame.io コンテキスト
 * @param args - 取り消す配置の情報
 * @returns void or INVALID_MOVE
 */
export interface UndoProductionPlacementArgs {
  side: 'light' | 'dark';
  column: number;
  columnType: 'city' | 'newCity';
  row: number;
}

export function undoProductionPlacement(
  { G, ctx }: { G: AoSGameState; ctx: Ctx },
  args: UndoProductionPlacementArgs
): void | typeof INVALID_MOVE {
  // 1. Production選択チェック
  const player = G.players[ctx.currentPlayer];
  if (player.selectedAction !== 'PRODUCTION') {
    console.error(`[undoProductionPlacement] Production not selected`);
    return INVALID_MOVE;
  }

  // 2. 配置済みチェック（1個以上配置されている必要がある）
  if (!G.productionPlacementCount || G.productionPlacementCount < 1) {
    console.error(`[undoProductionPlacement] No placements to undo`);
    return INVALID_MOVE;
  }

  // 3. 列を取得
  const columns = args.side === 'light' ? G.goodsDisplay.lightSide : G.goodsDisplay.darkSide;
  let column;
  if (args.columnType === 'newCity') {
    column = columns.find(col =>
      col.newCityId !== null &&
      col.columnNumber === args.column
    );
  } else {
    column = columns.find(col =>
      col.cityId !== '' &&
      col.newCityId === null &&
      col.columnNumber === args.column
    );
  }

  if (!column) {
    console.error(`[undoProductionPlacement] Column not found`);
    return INVALID_MOVE;
  }

  // 4. セルにキューブがあるかチェック
  const cubeColor = column.cubes[args.row];
  if (cubeColor === null) {
    console.error(`[undoProductionPlacement] Cell is empty, nothing to undo`);
    return INVALID_MOVE;
  }

  // 5. キューブを削除
  column.cubes[args.row] = null;
  debug.log(`[undoProductionPlacement] Removed ${cubeColor} from column ${args.column}, row ${args.row} (${args.side} side, ${args.columnType})`);

  // 6. 配置カウントをデクリメント
  G.productionPlacementCount -= 1;
  debug.log(`[undoProductionPlacement] Placement count: ${G.productionPlacementCount}/2`);
}
